import { render, staticRenderFns } from "./ElementList.vue?vue&type=template&id=3474fdea&"
import script from "./ElementList.vue?vue&type=script&lang=js&"
export * from "./ElementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3474fdea')) {
      api.createRecord('3474fdea', component.options)
    } else {
      api.reload('3474fdea', component.options)
    }
    module.hot.accept("./ElementList.vue?vue&type=template&id=3474fdea&", function () {
      api.rerender('3474fdea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/elements/ElementList.vue"
export default component.exports